// extracted by mini-css-extract-plugin
module.exports = {"select":"styles_select__38NZX","editor":"styles_editor__3Sl62","page":"styles_page__1AvGf"};